import { FC, Fragment } from "react";
import SRC from "./TheBride.jpg";
// import SRC from "./TheBride1.png";

export const TheBride: FC = () => {
  return (
    <Fragment>
      <img src={SRC} alt="" />
      <div className="hover-info neela-style">
        <span className="h-lines"></span>
        <span className="v-lines"></span>
        <div className="content">
          <h3 style={{ fontWeight: 100 }}>
            Anastasiia
            <br />
            Prykhodko<small>The Bride</small>
          </h3>
          <p>
            She's everything I've always dreamed of and I'm so excited to spend
            the rest of my life with her!
          </p>
          <ul className="sn-icons">
            <li>
              <a
                href="https://www.instagram.com/an.prykhodko"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-instagram-square"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </Fragment>
  );
};
